import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { noHtmlTagValidator } from '~/core/validators/no-html-tag/no-html-tag.validator';
import { FormControl, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';

import { FormControlChildAbstract } from '~/component/form/abstracts/control-child.abstract';

@Component({
  selector: 'app-form-textarea',
  templateUrl: './textarea.component.html',
  styleUrls: ['./textarea.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: FormTextareaComponent,
      multi: true,
    },
  ],
})
export class FormTextareaComponent
  extends FormControlChildAbstract<string>
  implements OnDestroy, OnInit
{
  @Input() public hasMinLengthError?: boolean;
  @Input() public maxLength?: number;
  @Input() public minLength?: number;
  @Input() public placeholder?: string;
  @Input() public rows?: number;

  private readonly subscriptions = new Subscription();

  public textarea: FormControl;

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public ngOnInit(): void {
    this.textarea = new FormControl('');

    if (this.minLength) {
      this.textarea.addValidators(Validators.minLength(this.minLength));
    }

    if (this.maxLength) {
      this.textarea.addValidators(Validators.maxLength(this.maxLength));
    }

    this.textarea.addValidators(noHtmlTagValidator());

    this.textarea.valueChanges.subscribe((value) => {
      this.value = value;
    });
  }

  public get currentCharactersCounter(): string {
    return this.textarea?.value?.length || 0;
  }

  public get hasCounter(): boolean {
    return !!(this.minLength || this.maxLength);
  }

  public writeValue(value: string): void {
    this.textarea.setValue(value);

    super.writeValue(value);
  }
}
